import { render, staticRenderFns } from "./Committee.vue?vue&type=template&id=38411f5a&scoped=true&"
import script from "./Committee.vue?vue&type=script&lang=js&"
export * from "./Committee.vue?vue&type=script&lang=js&"
import style0 from "./Committee.vue?vue&type=style&index=0&id=38411f5a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38411f5a",
  null
  
)

export default component.exports